import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-activity-skeleton-loader',
  templateUrl: './activity-skeleton-loader.component.html',
  styleUrl: './activity-skeleton-loader.component.scss'
})
export class ActivitySkeletonLoaderComponent {
  @Input() eventCount: number = 20;

  get skeletonEvents() {
    return Array.from({ length: this.eventCount }, (_, i) => ({
      id: i,
      hasDescription: Math.random() > 0.2,
      hasLink: Math.random() > 0.6,
      descriptionLines: Math.floor(Math.random() * 4) + 1,
      descriptionWidths: this.generateDescriptionWidths(),
      hasMultipleLines: Math.random() > 0.5,
      titleWidth: Math.floor(Math.random() * 30) + 50
    }));
  }

  private generateDescriptionWidths(): string[] {
    const lines = Math.floor(Math.random() * 3) + 1;
    return Array.from({ length: lines }, () => {
      const width = Math.floor(Math.random() * 40) + 60;
      return `${width}%`;
    });
  }
}
